import React from 'react';
import { Box, Button, ButtonBase, Checkbox, Collapse, Typography } from '@mui/material';
import { ExpandMoreOutlined, ChevronRightOutlined } from '@mui/icons-material';
import Tooltip from '../LibraryTooltip';

export default function KnowledgeShelfList({ contexts, contextCategories, expandedCategories, setExpandedCategories, includedContexts, onIncludeChange, onPreview, onRequestAccess }) {
  const groups = new Map();
  contexts.forEach((context) => {
    const type = String(contextCategories[context.id] ?? context.category ?? 'General').trim() || 'General';
    if (!groups.has(type)) groups.set(type, []);
    groups.get(type).push(context);
  });
  const multipleTypes = groups.size > 1;
  return [...groups.entries()].sort(([a], [b]) => a.localeCompare(b)).map(([type, items]) => {
    const expanded = expandedCategories[type] ?? (items.length <= 5);
    return (
      <Box key={type} sx={{ mb: 1, minWidth: 0 }}>
        {multipleTypes ? (
          <ButtonBase
            aria-expanded={expanded}
            onClick={() => setExpandedCategories((prev) => ({ ...prev, [type]: !expanded }))}
            sx={{ width: '100%', justifyContent: 'flex-start', gap: 0.5, py: 0.75, color: 'text.secondary', textAlign: 'left' }}
          >
            {expanded ? <ExpandMoreOutlined sx={{ fontSize: 18 }} /> : <ChevronRightOutlined sx={{ fontSize: 18 }} />}
            <Typography component="span" sx={{ fontSize: '0.75rem', fontWeight: 600 }}>{type} · {items.length}</Typography>
          </ButtonBase>
        ) : (
          <Typography sx={{ fontSize: '0.75rem', color: 'text.secondary', py: 0.5 }}>{type}</Typography>
        )}
        <Collapse in={!multipleTypes || expanded}>
          {items.map((context) => {
            const hasAccess = context.hasAccess !== false;
            const name = context.name || 'Untitled knowledge';
            return (
              <Box key={context.id} sx={{ display: 'flex', alignItems: 'center', minHeight: 36, gap: 0.5, minWidth: 0, '&:hover': { bgcolor: 'action.hover' } }}>
                <Checkbox
                  size="small"
                  sx={{ p: 0.5 }}
                  checked={hasAccess && includedContexts[context.id] !== false}
                  disabled={!hasAccess}
                  inputProps={{ 'aria-label': `Include ${name}` }}
                  onChange={(event) => onIncludeChange?.(context.id, event.target.checked)}
                />
                <Tooltip title={name} placement="right" describeChild>
                  <ButtonBase
                    disabled={!hasAccess}
                    onClick={() => onPreview?.(context.id)}
                    aria-label={`Preview ${name}`}
                    sx={{ flex: 1, minWidth: 0, justifyContent: 'flex-start', py: 0.75, textAlign: 'left' }}
                  >
                    <Typography noWrap sx={{ fontSize: '0.8125rem', minWidth: 0 }}>{name}</Typography>
                  </ButtonBase>
                </Tooltip>
                {!hasAccess && <Button size="small" onClick={() => onRequestAccess?.(context)}>Request</Button>}
              </Box>
            );
          })}
        </Collapse>
      </Box>
    );
  });
}
